<div id="swagger-ui">
</div>
<link rel="stylesheet" href="/assets/css/swagger/swagger-ui.css">
<link rel="stylesheet" href="/assets/css/swagger/theme-feeling-blue.css">